import { formatDevicesLabel } from './devicePricing';

export const SUBSCRIPTION_TITLE = 'Подписка';
export const SUBSCRIPTION_PERIOD_DAYS = 31;

export function resolveSubscriptionDevices(sub) {
    if (sub?.devices != null) {
        return Number(sub.devices);
    }
    return 2;
}

export function formatPeriodDaysLabel(days = SUBSCRIPTION_PERIOD_DAYS) {
    const n = Number(days) || SUBSCRIPTION_PERIOD_DAYS;
    const mod10 = n % 10;
    const mod100 = n % 100;

    if (mod10 === 1 && mod100 !== 11) {
        return `${n} день`;
    }
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
        return `${n} дня`;
    }
    return `${n} дней`;
}

export function formatPeriodPriceSuffix(days = SUBSCRIPTION_PERIOD_DAYS) {
    return `/ ${formatPeriodDaysLabel(days)}`;
}

export function formatDevicesShort(count) {
    return `${count} устр.`;
}

export function formatSubscriptionTitle(sub) {
    const devices = resolveSubscriptionDevices(sub);
    return `${SUBSCRIPTION_TITLE} · ${formatDevicesShort(devices)}`;
}

export function formatSubscriptionDevicesLabel(sub) {
    const devices = resolveSubscriptionDevices(sub);
    return `${devices} ${formatDevicesLabel(devices)}`;
}

export function formatSubscriptionDeletedMessage(sub) {
    const devices = resolveSubscriptionDevices(sub);
    return `${SUBSCRIPTION_TITLE} (${formatDevicesShort(devices)}) удалена`;
}
